import type { EncryptedKeyFile } from '../../lib/crypto/accessKey';
import { unsealPrivateKey, signChallenge } from '../../lib/crypto/accessKey';
import { buildChallenge } from '../../lib/crypto/challenge';

let privateKey: CryptoKey | null = null;
let keyId: string | null = null;

export const keySession = {
  async unlock(file: EncryptedKeyFile, password: string): Promise<void> {
    privateKey = await unsealPrivateKey(file, password); // throws Error('bad-password') on wrong password
    keyId = file.keyId;
  },
  isUnlocked(): boolean { return privateKey !== null; },
  lock(): void { privateKey = null; keyId = null; },
  async sign(req: { method: string; path: string; body: string }): Promise<{ header: string }> {
    if (!privateKey || !keyId) throw new Error('locked');
    const timestamp = Date.now();
    const nonce = crypto.randomUUID();
    const challenge = await buildChallenge({ ...req, timestamp, nonce });
    const sig = await signChallenge(privateKey, challenge);
    return { header: `${keyId}.${timestamp}.${nonce}.${sig}` };
  },
};
